module.exports = __webpack_public_path__ + "static/img/gs4.5012c434.jpg";